import { Chip } from '@ntuctech/devex-tangram'
import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider'
import styled from 'styled-components'
import Router, { withRouter } from 'next/router'
import React, { Component } from 'react'
import GlobalContext from '../GlobalContext'
import { CheckoutAddressConsumer } from '../CheckoutAddressProvider/CheckoutAddressProvider'
import { EventTrackingConsumer } from '../EventTrackingProvider/EventTrackingProvider'
import { GTM_ENV_VAR } from '../../lib/eventTrackerFunction'
import { AMP_EVENT_NAME as AEN, getPageTypeByUrl } from '../../lib/amplitude'
import { SCREEN_SIZE } from '../../lib/Media'
import Carousel from '../Carousel/Carousel'
import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'
import { removeItemsKeyword } from '../../lib/segment'
import { getGA4SuggestedImpressions } from '../../utils/Utils'

export const SearchSuggestionsContainer = styled.section`
  margin-bottom: 1.5rem;
  width: 100%;
  ${SCREEN_SIZE.From.Desktop} {
    width: calc(100% - 1.5rem);
  }

  & ul div {
    margin-bottom: 0;
  }

  ${SCREEN_SIZE.Only.Mobile} {
    margin-bottom: 0.5rem;
  }
`

export const Divider = styled.div`
  ${SCREEN_SIZE.Only.Mobile} {
    width: 100%;
    height: 1px;
    background-color: #eaeaea;
  }
`

class SearchSuggestionCollectionWrapper extends Component {
  constructor(props) {
    super(props)
    this.handleSearch = this.handleSearch.bind(this)
  }

  handleSearch = async item => {
    const GEV = GTM_ENV_VAR
    const refinementItems = this.props.data.collection.length
      ? this.props.data.collection.filter(
          suggestion => suggestion.suggestionType === 'keyword'
        )
      : []
    const getSelectedItemIndex = this.props.data.collection.length
      ? this.props.data.collection
          .filter(collection => collection.suggestionType === 'keyword')
          .findIndex(
            selectedSuggestion => item.name === selectedSuggestion.name
          )
      : ''

    const { isEnabled, configuration } =
      getConfigFor(SPLIT_FEATURES.FE_SEGMENT_SEARCH_COMPLETED) || {}
    const isSegmentEvent = isEnabled && configuration?.is_segment_on

    const defaultFeatureCount = {
      'refinement items': refinementItems.length,
    }

    const actualFeatureCount = []

    for (const label in defaultFeatureCount) {
      if (defaultFeatureCount[label]) {
        actualFeatureCount.push(`${label}: ${defaultFeatureCount[label]}`)
      }
    }

    const defaultFeatureContent = {
      'refinement items': isSegmentEvent
        ? refinementItems.map(val => val.name)
        : refinementItems.map(val => val.name).join(),
    }

    const actualFeatureContent = []

    for (const label in defaultFeatureContent) {
      if (defaultFeatureContent[label]) {
        actualFeatureContent.push(`${label}: ${defaultFeatureContent[label]}`)
      }
    }

    const segmentProps = {
      [GEV.SUGGESTED_KEYWORD_IMPRESSION]: removeItemsKeyword(
        defaultFeatureContent
      ),
      [GEV.SEARCH_FEATURES_COUNT]: removeItemsKeyword(defaultFeatureCount),
      [GEV.AMPLITUDE_SEARCH_TERM_SELECTED]: item.name,
    }

    const convertRefinementData = refinementItems.length
      ? refinementItems.map(data => {
          return {
            ...data,
            type: data.suggestionType,
          }
        })
      : []

    const ga4SuggestionsImpressions = getGA4SuggestedImpressions(
      [],
      [],
      [],
      convertRefinementData
    )

    const searchFeatureSelected = 'refinement'
    const userSearchCompletedEventParams = {
      SEARCH_SUGGESTED_CAMPAIGN_NAME: null,
      SEARCH_SUGGESTED_CAMPAIGN_NAME_COUNT: 0,
      SEARCH_POPULAR_CATEGORY_KEYWORDS: null,
      SEARCH_POPULAR_CATEGORY_KEYWORDS_COUNT: 0,
      SEARCH_RECENT_KEYWORDS: null,
      SEARCH_RECENT_KEYWORDS_COUNT: 0,
      SEARCH_AUTOCOMPLETE_KEYWORDS: null,
      SEARCH_AUTOCOMPLETE_KEYWORDS_COUNT: 0,
      SEARCH_TRENDING_KEYWORDS: null,
      SEARCH_TRENDING_KEYWORDS_COUNT: 0,
      SEARCH_TERM: this.props.router.query.query || null,
      SEARCH_TERM_TYPED: null,
      SEARCH_SEGMENTS: null,
      SEARCH_REFINEMENT_KEYWORDS: refinementItems.map(value => value.name),
      SEARCH_REFINEMENT_KEYWORDS_COUNT: refinementItems.length,
      SEARCH_FEATURE_SELECTED: searchFeatureSelected,
      SEARCH_FEATURE_POSITION: getSelectedItemIndex + 1,
      SEARCH_PRODUCT_COUNT: 0,
    }
    sessionStorage.setItem(
      'searchData',
      JSON.stringify(userSearchCompletedEventParams)
    )

    this.props.track({
      [GEV.AMPLITUDE_EVENT_NAME]: AEN.SEARCH_COMPLETED,
      [GEV.KEYWORD_SELECTED]: item.name,
      [GEV.AMPLITUDE_SEARCH_FEATURE_SELECTED]: 'refinement',
      [GEV.AMPLITUDE_ITEM_POSITIONS]: getSelectedItemIndex + 1,
      [GEV.SEARCH_FEATURES_COUNT]: actualFeatureCount,
      [GEV.AMPLITUDE_CTA_LOCATION]: {
        pageName: getPageTypeByUrl(),
        pageMeta: [this.props.router.query.query] || [],
      },
      [GEV.AMPLITUDE_CTA_SUBLOCATION]: null,
      [GEV.SEARCH_FEATURES_COUNT]: actualFeatureCount,
      // GA
      [GEV.EVENT_CAT]: 'Product-Core',
      [GEV.EVENT_ACTION]: 'SearchComplete',
      [GEV.EVENT_LABEL]: 'SearchFeatureSelected: refinement',
      [GEV.SCREEN_NAME]: 'Search Result',
      [GEV.PAGE_TYPE]: 'search',
      [GEV.KEYWORD_SELECTED]: item.name,
      [GEV.ASSET_TYPE]: 'FPON',
      [GEV.SEARCH_POSITION]: getSelectedItemIndex + 1,
      [GEV.SUGGESTED_KEYWORD_IMPRESSION]: actualFeatureContent,
      [GEV.SUGGESTED_SEARCH_IMPRESSION]: actualFeatureContent,
      [GEV.FUL_CENTER]: this.props.checkoutAddress?.storeType,
      [GEV.IS_SEGEMENT_EVENT]: isSegmentEvent,
      ...ga4SuggestionsImpressions,
      ...(isSegmentEvent && segmentProps),
    })

    Router.push(`/search?query=${encodeURIComponent(item.name)}`)
  }

  render() {
    const { data } = this.props
    return (
      <NdsThemeProvider>
        <SearchSuggestionsContainer data-testid="search-suggestions">
          <Carousel infiniteScrolling hasMore>
            {data.collection.length &&
              data.collection.map((item, index) => {
                return (
                  <Chip
                    role="listitem"
                    data-testid="search-suggestion-item"
                    key={item.name + index}
                    label={item.name}
                    onClick={() => this.handleSearch(item)}
                  />
                )
              })}
          </Carousel>
        </SearchSuggestionsContainer>
        <Divider />
      </NdsThemeProvider>
    )
  }
}

const SearchSuggestionCollection = props => (
  <GlobalContext.Consumer>
    {({ remoteConfig, experiments }) => (
      <CheckoutAddressConsumer>
        {({ checkoutAddress }) => (
          <EventTrackingConsumer>
            {({ track, getTestVersions }) => (
              <React.Fragment>
                <div />
                {/* Needed for avoiding layout shifting in the home page */}
                <SearchSuggestionCollectionWrapper
                  checkoutAddress={checkoutAddress}
                  {...props}
                  track={track}
                  remoteConfig={remoteConfig}
                  experiments={experiments}
                  getTestVersions={getTestVersions}
                />
              </React.Fragment>
            )}
          </EventTrackingConsumer>
        )}
      </CheckoutAddressConsumer>
    )}
  </GlobalContext.Consumer>
)

export default withRouter(SearchSuggestionCollection)
